import { type ContentTableItem } from "src/components/ContentTable/ContentTable";

export const mapRegionsToContentTableItems = (
	regions: Region[]
): ContentTableItem[] => {
	return regions.map((region) => ({
		id: region.id,
		name: region.name,
		isActive: true,
		lastUpdated: region.updatedAt,
		data: {
			manager: region.regionManager?.name ?? "—",
			lastsync: region.lastsync
		}
	}));
};
